import RestClient from "./RestClient";

const VisitorProfileAPI = {};

VisitorProfileAPI.install = (Vue) => {
  const vue = Vue;
  vue.prototype.$VisitorProfileAPI = {
    queryVisitorProfile(data) {
      return RestClient.post(`/query-visitor-profile`, data);
    },
    addVisitorProfile(data) {
      return RestClient.post(`/add-visitor-profile`, data);
    },
    updateVisitorProfile(data) {
      return RestClient.post(`/update-visitor-profile`, data);
    },
    addVisitorTrackingLog(data) {
      return RestClient.post(`/add-visitor-tracking-log`, data);
    },
  };
};

export default VisitorProfileAPI;
